import { type ItemSetCondition, type ItemSetCreation } from '@exam-management/graphql';

function getItemSetCreatedCount(itemSetCreation: ItemSetCreation[], size: number) {
  return itemSetCreation.filter((creation) => creation.size === size).length;
}

export function getQuestionCreationMenu(
  singleCreation: number,
  singleCondition: number,
  itemSetCreation: ItemSetCreation[],
  itemSetCondition: ItemSetCondition[],
  pathPrefix: 'task-management' | 'my-task',
) {
  const options = [];

  // Option appear only when requirement included single question and not met with requirement
  if (singleCondition) {
    options.push({
      label: 'Single',
      path: `/${pathPrefix}/question-creation/:taskId/single/create`,
      disabled: singleCreation >= singleCondition,
    } as const);
  }

  for (const itemSet of itemSetCondition ?? []) {
    options.push({
      label: `Item Set: ${itemSet.size}Q`,
      path: `/${pathPrefix}/question-creation/:taskId/item-set/create?size=${itemSet.size}`,
      disabled: getItemSetCreatedCount(itemSetCreation, itemSet.size) >= itemSet.needTotal,
    } as const);
  }
  return options;
}
